export default __webpack_public_path__ + "i18n/translations/translation-te.47196ba3.json";